import React, { useState } from "react";
import { useQueryClient, useIsFetching } from "react-query";
import TabBar from "ManagementTeam/Shared/TabBar";
import { Toaster } from "react-hot-toast";
import { Header } from "../Shared/Header/Header";
import { Dashboard } from "../DashboardPage/useDashboard";

import Committees from "./Committees";
import ArchivedCommittees from "./ArchivedCommittees";

import styles from "./CommitteesPage.module.css";
import icon from "./Committees_Icon.svg";
import Auth from "shared/@auth";

export function CommitteesPage() {
  const { hasPermission } = Auth.useContainer();
  const readOnly = !hasPermission("management-team.admins");
  const [currentPage, changeCurrentPage] = useState("Committees");
  const { refetchDashboard, isFetching } = Dashboard.useContainer();
  const [isRefreshing, setIsRefreshing] = useState(false);
  const queryClient = useQueryClient();
  const isCurrentFetching = useIsFetching("current") > 0;
  const isArchivedFetching = useIsFetching("archived") > 0;

  const handleRefresh = async () => {
    setIsRefreshing(true);
    try {
      await Promise.all([
        refetchDashboard(),
        // Ensure both active and archived committees re-fetch
        queryClient.invalidateQueries("current"),
        queryClient.invalidateQueries("archived"),
      ]);
    } finally {
      setIsRefreshing(false);
    }
  };

  return (
    <div className={styles.committeesPageContainer}>
      <div className={styles.sticky}>
        <div className={styles.pageHeader}>
          <Header
            title={"Committees"}
            icon={icon}
            children={
              <div className={styles.tabBar}>
                <TabBar
                  activeTitle={currentPage}
                  titleList={[
                    { title: "Committees", notification: 0 },
                    { title: "Archived Committees", notification: 0 },
                  ]}
                  onChange={changeCurrentPage}
                />
              </div>
            }
            onRefresh={handleRefresh}
            isLoading={
              isRefreshing ||
              isFetching ||
              isCurrentFetching ||
              isArchivedFetching
            }
          />
        </div>
      </div>
      <div
        className={
          currentPage === "Committees"
            ? styles.pageBody
            : styles.archivePageBody
        }
      >
        {currentPage === "Committees" && <Committees readOnly={readOnly} />}
        {currentPage === "Archived Committees" && (
          <ArchivedCommittees readOnly={readOnly} />
        )}
      </div>
      <Toaster position="bottom-center" />
    </div>
  );
}
